/*
This file is located in the main branch
Last time the file was updated (UTC): [26.07.2024 9:54:27]
Permissions to update outside the main branch: [false]
*/

import { Filter } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { RoleChange, RoleFilter, RoleItem, RoleTableItem, RoleType } from 'models/api/roles';
import ResTable from 'models/api/table';

export const getRolesList = async (axios: AxiosInstance, params: Filter<RoleFilter>) => {
    const resp = await axios.get<ResTable<RoleTableItem>>('/roles', {
        params: { showTechnical: true, ...params },
    });
    return resp.data;
};

export const getRolesByParentId = async (axios: AxiosInstance, id: string) =>
    await getRolesList(axios, { parentId: id });

export const getRolesByLevel = async (axios: AxiosInstance, level: number) =>
    await getRolesList(axios, { level: level });

export const getRole = async (axios: AxiosInstance, id: string | number) => {
    const { data } = await axios.get<RoleTableItem>(`/roles/${id}`);
    return data;
};

export const addRole = async (axios: AxiosInstance, item: RoleItem) =>
    await axios.post('/roles', item);

export const changeRole = async (axios: AxiosInstance, item: RoleChange) =>
    await axios.put(`/roles/${item.id}`, item);

export const deleteRole = async (axios: AxiosInstance, id: string | number) =>
    await axios.delete(`/roles/${id}`);

export const getRoleTypes = async (axios: AxiosInstance) => {
    const { data } = await axios.get<RoleType[]>('/roles/types');
    return data;
};

export const resetRoleCache = async (axios: AxiosInstance) =>
    await axios.post(`/roles/cache/reset`);

export const getRolesExcel = async (axios: AxiosInstance, params: Filter<RoleFilter>) => {
    const { data } = await axios.get<Blob>('/roles/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};
